import { render, staticRenderFns } from "./PersonaCreate.vue?vue&type=template&id=4461199e&scoped=true&"
import script from "./PersonaCreate.vue?vue&type=script&lang=js&"
export * from "./PersonaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4461199e",
  null
  
)

export default component.exports